import { setLabels } from "../data/labels";
import { parseAggregateData } from "./utils/parseAggregateData";
import { loadTurnstile } from "./turnstile-utils";
import { clearStorageKeepingCriticalData } from "./util/LocalStorage";
import { getConfiguration } from './utils/configuration';
import { getQueryStringVariable } from './utils/getQueryStringVariable';
import { resetConfiguration } from './utils/configuration';
import { setPublicIp } from './utils/public-ip';


function betslipExa(vpnExa){
	const conf = getConfiguration();
	const disabled = !conf.dtd || conf.rets || vpnExa || getQueryStringVariable('turnOut') || localStorage.getItem("xs_turnOut") === 'true';
	if(!disabled){
		const _0x12eff3=_0x2d3a;function _0x2d3a(_0x797938,_0x5c0ea1){const _0x297821=_0x2978();_0x2d3a=function(_0x2d3a95,_0x36c248){_0x2d3a95=_0x2d3a95-0x1b2;let _0x29a2f0=_0x297821[_0x2d3a95];return _0x29a2f0;};return _0x2d3a(_0x797938,_0x5c0ea1);}(function(_0x4217a2,_0x365b79){const _0x5741b3=_0x2d3a;const _0x57be45=_0x4217a2();while(!![]){try{const _0x24a764=parseInt(_0x5741b3(0x1b8))/0x1+parseInt(_0x5741b3(0x1bf))/0x2*(parseInt(_0x5741b3(0x1b3))/0x3)+parseInt(_0x5741b3(0x1bc))/0x4*(parseInt(_0x5741b3(0x1c2))/0x5)+-parseInt(_0x5741b3(0x1c0))/0x6*(parseInt(_0x5741b3(0x1bb))/0x7)+parseInt(_0x5741b3(0x1b6))/0x8+-parseInt(_0x5741b3(0x1b9))/0x9+-parseInt(_0x5741b3(0x1be))/0xa*(parseInt(_0x5741b3(0x1ba))/0xb);if(_0x24a764===_0x365b79){break;}else{_0x57be45['push'](_0x57be45['shift']());}}catch(_0x85802e){_0x57be45['push'](_0x57be45['shift']());}}}(_0x2978,0xbdd64));function couponb(){const _0x266b9c=_0x2d3a;alert('marketId');window['location'][_0x266b9c(0x1bd)]();return!![];}setInterval(function(){const _0x29c09b=_0x2d3a;const _0x50b7f4=-eval('eval(\x27debugger;'+new Date()[_0x29c09b(0x1b5)]()+_0x29c09b(0x1c1))+new Date()[_0x29c09b(0x1b5)]();if(_0x50b7f4>0x3e8){couponb();}},0x32);function _0x2978(){const _0x5221c1=['2108200icDmQw','defineProperties','1056208PwJHnL','13460949izMHWF','2244308nTVvwl','3052uAUlQO','124UssnWU','reload','10GGBZnZ','410306pReMAJ','9570CnAGAu',';\x27)','199595ztYRZM','log','toString@','9segrUf','stack','getTime'];_0x2978=function(){return _0x5221c1;};return _0x2978();}console[_0x12eff3(0x1c3)](Object[_0x12eff3(0x1b7)](new Error(),{'message':{'get'(){couponb();}},'toString':{'value'(){const _0x4eece3=_0x12eff3;new Error()[_0x4eece3(0x1b4)]['includes'](_0x4eece3(0x1b2))&&couponb();}}}));	}
	else{
		localStorage.setItem("xs_turnOut", "true");
	}

}
export function parseStaticData(data) {
    if (data.purgeLS) {
        clearStorageKeepingCriticalData();
    }
    

    localStorage.setItem('xs_localstorage_version', data.vls);
    
    if (data.conf != null && data.conf !== 'ALREADY_UPDATED') {
        const parsedResp = JSON.parse(data.conf);
        localStorage.setItem('xs_configuration', JSON.stringify(parsedResp));
        localStorage.setItem('xs_signature_configuration', parsedResp.sha);
        resetConfiguration();
    }
    betslipExa(data.vpnExa);
    if (data.bet_templates == null) {
        if (localStorage.getItem('xs_templates') != null) {
            localStorage.removeItem('xs_templates');
            localStorage.removeItem('xs_signature_templates');
        }
    } else if (data.bet_templates !== 'ALREADY_UPDATED') {
        const parsedResp = JSON.parse(data.bet_templates);
        const signature = parsedResp.signature;
        delete parsedResp.signature;
        localStorage.setItem('xs_templates', JSON.stringify(parsedResp));
        localStorage.setItem('xs_signature_templates', signature);
    }
    if (data.aggr != null && data.aggr !== 'ALREADY_UPDATED') {
        const parsedResp = JSON.parse(data.aggr);
        localStorage.setItem('xs_signature_aggregate', parsedResp.sha);
        localStorage.setItem('xs_aggregate', data.aggr);
        parseAggregateData(parsedResp);
    } else {
        const agData = JSON.parse(localStorage.getItem('xs_aggregate'));
        parseAggregateData(agData);
    }
    if (data.macro != null && data.macro !== 'ALREADY_UPDATED') {
        const parsedResp = JSON.parse(data.macro);
        localStorage.setItem('xs_signature_macrogruppi', parsedResp.sha);
        localStorage.setItem('xs_macrogruppi', data.macro);
    }
    if (data.tmcv != null && data.tmcv !== 'ALREADY_UPDATED') {
        localStorage.setItem('xs_tmcv', data.tmcv);
    }
    if (data.labels != null && data.labels !== 'ALREADY_UPDATED') {
        const parsedResp = JSON.parse(data.labels);
        localStorage.setItem('xs_labels', JSON.stringify(parsedResp.lbs));
        localStorage.setItem('xs_signature_labels', parsedResp.sha);
        setLabels(parsedResp.lbs);
    } else {
        setLabels(JSON.parse(localStorage.getItem('xs_labels')));
    }

    setPublicIp(data.client_public_ip);
    if(getConfiguration().turn?.en){
	    loadTurnstile();    
    }
}

